import Grid from "@material-ui/core/Grid";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import DynamicForm from "Component/DynamicForm";
import { ErrorMessages } from "Constants";
import { instance } from "Actions/AxiosInstance";
import { textareainputconverter } from "Component/DynamicForm/Fields/Textarea";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Paper from "@material-ui/core/Paper";
import CallOutNew from "Component/Headers/callOutNew";
import deleteIcon from "Assets/newicons/action/delete-bin/outline/delete-bin-outline-16px.svg";
import "./index.scss";
import Button from "@material-ui/core/Button";
import dragIcon from "Assets/Svg/drag.svg";

const getItems = (count) =>
  Array.from({ length: count }, (v, k) => k).map((k) => ({
    // id: `item-${k}`,
    id: `${k}`,
    content: `item ${k}`,
    name: "abcd",
  }));

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the pipelinestage look a bit nicer
  userSelect: "none",
  padding: "16px 0px 16px 16px",
  margin: `0 ${grid}px 0 0`,
  width: 184,
  display: "inline-block",
  whiteSpace: "normal",
  height: 400,
  // overflowX: "hidden",
  // overflowY: "auto",

  // change background colour if dragging
  background: isDragging ? "#f7f8f8" : "#fff",

  // styles we need to apply on draggables
  ...draggableStyle,
});

const getListStyle = (isDraggingOver) => ({
  // background: isDraggingOver ? "lightblue" : "#fff",
  background: "#fff",
  // display: "flex",
  overflowX: "auto",
  whiteSpace: "nowrap",
  paddingBottom: 24,
});

class design extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      postData: this.props.postData,
      stagename: null,
      pipelinestage:
        this.props.postData &&
        this.props.postData.pipelinestage &&
        this.props.postData.pipelinestage.length > 0
          ? this.props.postData.pipelinestage
          : [
              {
                pipelinestageid: null,
                stagename: "New",
                description: null,
                stagecategoryid: 1,
                stageorder: 1,
                pipelineconfigmail: null,
              },
              {
                pipelinestageid: null,
                stagename: "Screening",
                description: null,
                stagecategoryid: 2,
                stageorder: 2,
                pipelineconfigmail: null,
              },
              {
                pipelinestageid: null,
                stagename: "Interviewing",
                description: null,
                stagecategoryid: 3,
                stageorder: 3,
                pipelineconfigmail: null,
              },
              {
                pipelinestageid: null,
                stagename: "Offered",
                description: null,
                stagecategoryid: 4,
                stageorder: 4,
                pipelineconfigmail: null,
              },
              {
                pipelinestageid: null,
                stagename: "Disqualify",
                description: null,
                stagecategoryid: 5,
                stageorder: 5,
                pipelineconfigmail: null,
              },
              {
                pipelinestageid: null,
                stagename: "Hired",
                description: null,
                stagecategoryid: 6,
                stageorder: 6,
                pipelineconfigmail: null,
              },
            ],
      stageCategoryId: "",
      stageCategories: [
        // {
        //   displayvalue: 1,
        //   displayname: "New",
        // },
        {
          displayvalue: 2,
          displayname: "Screening",
        },
        {
          displayvalue: 3,
          displayname: "Interviewing",
        },
        {
          displayvalue: 4,
          displayname: "Offered",
        },
        // {
        //   displayvalue: 5,
        //   displayname: "Disqualified",
        // },
        // {
        //   displayvalue: 6,
        //   displayname: "Hired",
        // },
      ],
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
    this.addStageAfter = this.addStageAfter.bind(this);
    this.addStageBefore = this.addStageBefore.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onSaveDraft = this.onSaveDraft.bind(this);
  }

  async componentDidMount() {
    this.props.onRef({
      onNext: this.onSubmit,
      onSaveDraft: this.state.postData.pipelineid ? "" : this.onSaveDraft,
    });
  }

  onDelete(index) {
    console.log("index: ", index);
    const { pipelinestage } = this.state;
    pipelinestage.splice(index, 1);
    this.setState({
      pipelinestage,
    });
  }

  addStageBefore(index, stagecategoryid) {
    const { pipelinestage } = this.state;
    const objTemp = {
      pipelinestageid: null,
      stagename: "Stage name",
      description: null,
      stagecategoryid,
      stageorder: index + 1,
      pipelineconfigmail: null,
    };

    pipelinestage.splice(index, 0, objTemp);

    this.setState({
      pipelinestage,
    });
  }

  addStageAfter(index, stagecategoryid) {
    const { pipelinestage } = this.state;
    const objTemp1 = {
      pipelinestageid: null,
      stagename: "Stage name",
      description: null,
      stagecategoryid: stagecategoryid == 1 ? 2 : stagecategoryid,
      stageorder: index + 1,
      pipelineconfigmail: null,
    };

    pipelinestage.splice(index + 1, 0, objTemp1);

    this.setState({
      pipelinestage,
    });
  }

  onDragEnd(result) {
    console.log("result: ", result);
    // dropped outside the list
    const element =
      this.state.pipelinestage[this.state.pipelinestage.length - 1];
    const element1 =
      this.state.pipelinestage[this.state.pipelinestage.length - 2];
    const idx = this.state.pipelinestage.lastIndexOf(element);
    const idx1 = this.state.pipelinestage.lastIndexOf(element1);
    console.log("idx: ", idx);
    // this.state.pipelinestage.lastIndexOf(this.state.pipelinestage.length - 1)
    if (
      idx != (result.destination && result.destination.index) &&
      idx1 != (result.destination && result.destination.index) &&
      (result.destination && result.destination.index) != 0
    ) {
      const pipelinestage = reorder(
        this.state.pipelinestage,
        result.source && result.source.index,
        result.destination && result.destination.index,
      );

      this.setState({
        pipelinestage,
      });
    }
  }

  onSaveDraft() {
    let isvalid = true;
    const { pipelinestage, postData } = this.state;
    postData.isdraft = true;
    pipelinestage.map((item, index) => {
      if (!item.stagename) {
        isvalid = false;
      } else if (!item.stagecategoryid) {
        isvalid = false;
      }
    });
    if (isvalid == false) {
      this.props.enqueueSnackbar("Please fill all required field", {
        variant: "error",
      });
    } else {
      postData.noofstage = pipelinestage.length;
      postData.pipelinestage = pipelinestage;
      instance
        .post("recruit/configpipeline", postData)
        .then(() => {
          this.props.enqueueSnackbar(ErrorMessages.E0000, {
            variant: "success",
          });
          this.props.history.push(`${this.props.match.path}`);
          this.props.getPipeline();
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  }

  handleChange(key, value, index) {
    const { pipelinestage } = this.state;
    pipelinestage[index][key] = value;
    this.setState({ pipelinestage });
  }

  handleBlur(key, value, index) {
    const { pipelinestage } = this.state;
    pipelinestage[index][key] = value;
    this.setState({ pipelinestage });
  }

  onSubmit() {
    let isvalid = true;
    const { pipelinestage, postData } = this.state;

    postData.isdraft = true;
    let isduplicate = false;

    const map = {};

    for (let i = 0; i < pipelinestage.length; i++) {
      // check if object contains entry with this element as key
      if (map[pipelinestage[i].stagename]) {
        isduplicate = true;
        // terminate the loop
        break;
      }
      // add entry in object with the element as key
      map[pipelinestage[i].stagename] = true;
    }
    console.log("isduplicate: ", isduplicate);
    this.state.pipelinestage.map((item, index) => {
      if (!item.stagename) {
        isvalid = false;
      } else if (!item.stagecategoryid) {
        isvalid = false;
      }
    });

    if (isvalid == false) {
      this.props.enqueueSnackbar("Please fill all required field", {
        variant: "error",
      });
    } else if (isduplicate) {
      this.props.enqueueSnackbar("Stage name should be unique", {
        variant: "error",
      });
    } else {
      postData.noofstage = this.state.pipelinestage.length;
      postData.pipelinestage = this.state.pipelinestage;
      this.props.onNextClick(postData);
    }
  }

  render() {
    return (
      <div className="stepper-scroller padding-top-0">
        <Grid container>
          <Grid item xs={12} md={12} sm={12}>
            <DragDropContext onDragEnd={this.onDragEnd}>
              <Droppable droppableId="droppable" direction="horizontal">
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    style={getListStyle(snapshot.isDraggingOver)}
                    {...provided.droppableProps}
                    className="thin-scroll1"
                  >
                    {this.state.pipelinestage.map((item, index) => (
                      <Draggable
                        key={item.stagename}
                        draggableId={item.stagename}
                        index={index}
                        // isDragging={false}
                        isDragDisabled={
                          item.stagecategoryid == 1 ||
                          item.stagecategoryid == 5 ||
                          item.stagecategoryid == 6
                            ? true
                            : false
                        }
                      >
                        {(provided, snapshot) => (
                          <Paper
                            className="rounded-rectangle-paper stage-outer position-rel"
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={getItemStyle(
                              snapshot.isDragging,
                              provided.draggableProps.style,
                            )}
                          >
                            <div
                              className="thin-scroll"
                              style={{
                                overflowY: "auto",
                                width: 168,
                                overflowX: "hidden",
                                height: "100%",
                                paddingRight: 16,
                              }}
                              key={index}
                            >
                              <div style={{ width: "inherit" }}>
                                <div
                                  className="text-center"
                                  style={
                                    item.stagecategoryid == 1 ||
                                    item.stagecategoryid == 2 ||
                                    item.stagecategoryid == 6
                                      ? { opacity: 0 }
                                      : { opacity: 1 }
                                  }
                                >
                                  <img
                                    src={dragIcon}
                                    style={{ transform: "rotate(90deg)" }}
                                  ></img>
                                </div>

                                <p className="normal-dark-secondary text-center t-bold margin-bottom-8">
                                  {item.stagename}
                                </p>
                                <span
                                  style={{
                                    // width: 92,
                                    textAlign: "center",
                                    fontSize: 12,
                                    borderRadius: 4,
                                    backgroundColor:
                                      item.stagecategoryid == 1
                                        ? "#d5b8ff"
                                        : item.stagecategoryid == 2
                                        ? "#fffcd1"
                                        : item.stagecategoryid == 3
                                        ? "#d9ffff"
                                        : item.stagecategoryid == 4
                                        ? "#d9ffdf"
                                        : item.stagecategoryid == 5
                                        ? "#ffdddd"
                                        : item.stagecategoryid == 6
                                        ? "#82bdff"
                                        : "",
                                    padding: "8px 16px",
                                    fontWeight: "bold",
                                    display: "block",
                                    marginBottom: 16,
                                    color: "#292929",
                                  }}
                                >
                                  {item.stagecategoryid == 1
                                    ? "New"
                                    : item.stagecategoryid == 2
                                    ? "Screening"
                                    : item.stagecategoryid == 3
                                    ? "Interviewing"
                                    : item.stagecategoryid == 4
                                    ? "Offered"
                                    : item.stagecategoryid == 5
                                    ? "Disqualified"
                                    : item.stagecategoryid == 6
                                    ? "Hired"
                                    : "new stage"}
                                </span>
                                <div className="dashed-divider1"></div>
                                <DynamicForm
                                  fields={textinputconverter({
                                    autoFocus: true,
                                    value:
                                      this.state.pipelinestage[index].stagename,
                                    id: index,
                                    placeholder: "",
                                    label: "Stage name",
                                    disabled:
                                      (item.stagecategoryid == 1 &&
                                        item.stagename == "New") ||
                                      item.stagecategoryid == 5 ||
                                      item.stagecategoryid == 6
                                        ? true
                                        : false,
                                  })}
                                  onChange={(value) => {
                                    this.handleChange(
                                      "stagename",
                                      value,
                                      index,
                                    );
                                  }}
                                />
                                <DynamicForm
                                  fields={selectinputconverter({
                                    value:
                                      item.stagecategoryid == 1
                                        ? 1
                                        : this.state.pipelinestage[index]
                                            .stagecategoryid,
                                    placeholder:
                                      item.stagecategoryid == 1
                                        ? "New"
                                        : item.stagecategoryid == 5
                                        ? "Disqualify"
                                        : item.stagecategoryid == 6
                                        ? "Hired"
                                        : "",
                                    label: "Stage category",
                                    options: this.state.stageCategories,

                                    disabled:
                                      (item.stagecategoryid == 1 &&
                                        item.stagename == "New") ||
                                      item.stagecategoryid == 5 ||
                                      item.stagecategoryid == 6
                                        ? true
                                        : false,
                                  })}
                                  onChange={(selectedid) => {
                                    this.handleChange(
                                      "stagecategoryid",
                                      selectedid,
                                      index,
                                    );
                                  }}
                                />
                                {item.stagecategoryid == 1 && (
                                  <CallOutNew
                                    classnames="bg-light-blue width100"
                                    header="👉 New applications will collate here!"
                                    emoji=""
                                    textcolor="#1e8ced"
                                  />
                                )}
                                {(item.stagecategoryid == 5 ||
                                  item.stagecategoryid == 6) && (
                                  <CallOutNew
                                    classnames="bg-light-blue width100"
                                    header="👀 This stage will be hidden by default"
                                    emoji=""
                                    textcolor="#1e8ced"
                                  />
                                )}

                                <div
                                  className="delete-stage"
                                  style={
                                    item.stagecategoryid == 2 ||
                                    item.stagecategoryid == 3 ||
                                    item.stagecategoryid == 4
                                      ? { opacity: 1 }
                                      : { opacity: 0, display: "none" }
                                  }
                                >
                                  <img src={deleteIcon}></img>
                                </div>

                                <div
                                  className="delete-stage-btn"
                                  style={
                                    item.stagecategoryid == 2 ||
                                    item.stagecategoryid == 3 ||
                                    item.stagecategoryid == 4
                                      ? {}
                                      : { opacity: 0, display: "none" }
                                  }
                                >
                                  <Button
                                    variant="contained"
                                    className="btn btn-primary-sm-red"
                                    color="primary"
                                    onClick={() => this.onDelete(index)}
                                  >
                                    Delete stage
                                  </Button>
                                </div>

                                <div className="add-stage">
                                  {item.stagecategoryid == 2 ||
                                  item.stagecategoryid == 3 ||
                                  item.stagecategoryid == 4 ? (
                                    <div
                                      className="add-stage-before"
                                      onClick={() =>
                                        this.addStageBefore(
                                          index,
                                          item.stagecategoryid,
                                        )
                                      }
                                    >
                                      <svg
                                        width="16px"
                                        height="16px"
                                        viewBox="0 0 16 16"
                                        version="1.1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                      >
                                        <g
                                          stroke="none"
                                          strokeWidth="1"
                                          fill="none"
                                          fillRule="evenodd"
                                        >
                                          <g id="e-add">
                                            <rect
                                              id="Rectangle"
                                              x="0"
                                              y="0"
                                              width="16"
                                              height="16"
                                            ></rect>
                                            <g
                                              id="Group"
                                              transform="translate(1.000000, 1.000000)"
                                              stroke="#1e8ced"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                            >
                                              <path
                                                d="M7.5,0.5 L7.5,14.5"
                                                id="Path"
                                              ></path>
                                              <path
                                                d="M0.5,7.5 L14.5,7.5"
                                                id="Path"
                                              ></path>
                                            </g>
                                          </g>
                                        </g>
                                      </svg>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                  {item.stagecategoryid == 1 ||
                                  item.stagecategoryid == 2 ||
                                  item.stagecategoryid == 3 ||
                                  item.stagecategoryid == 4 ? (
                                    <div
                                      className="add-stage-after"
                                      onClick={() =>
                                        this.addStageAfter(
                                          index,
                                          item.stagecategoryid,
                                        )
                                      }
                                    >
                                      <svg
                                        width="16px"
                                        height="16px"
                                        viewBox="0 0 16 16"
                                        version="1.1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                      >
                                        <g
                                          stroke="none"
                                          strokeWidth="1"
                                          fill="none"
                                          fillRule="evenodd"
                                        >
                                          <g id="e-add">
                                            <rect
                                              id="Rectangle"
                                              x="0"
                                              y="0"
                                              width="16"
                                              height="16"
                                            ></rect>
                                            <g
                                              id="Group"
                                              transform="translate(1.000000, 1.000000)"
                                              stroke="#1e8ced"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                            >
                                              <path
                                                d="M7.5,0.5 L7.5,14.5"
                                                id="Path"
                                              ></path>
                                              <path
                                                d="M0.5,7.5 L14.5,7.5"
                                                id="Path"
                                              ></path>
                                            </g>
                                          </g>
                                        </g>
                                      </svg>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                            </div>
                          </Paper>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </Grid>
        </Grid>
      </div>
    );
  }
}
export default withSnackbar(design);
